import * as Types from '../../generated.types'

import { FinchConnectionDetailFragmentDoc } from '../../fragments/FinchConnectionFragment_gen'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type CreateFinchSessionMutationVariables = Types.Exact<{
  input: Types.CreateFinchSessionInput
}>

export type CreateFinchSessionMutation = {
  __typename?: 'Mutation'
  createFinchSession?: {
    __typename?: 'CreateFinchSessionPayload'
    finchConnection: {
      __typename: 'FinchConnection'
      id: number
      sessionId?: string | null
      displayLabel?: string | null
      isActive: boolean
      status?: Types.FinchConnectionStatus | null
      hasAuthenticatedEver: boolean
    }
    inputErrors: Array<{ __typename?: 'InputError'; argument: string; message: string }>
  } | null
}

export const CreateFinchSessionDocument = `
    mutation createFinchSession($input: CreateFinchSessionInput!) {
  createFinchSession(input: $input) {
    finchConnection {
      ...FinchConnectionDetail
    }
    inputErrors {
      argument
      message
    }
  }
}
    ${FinchConnectionDetailFragmentDoc}`
export const useCreateFinchSessionMutation = <TError = Error, TContext = unknown>(
  options?: UseMutationOptions<
    CreateFinchSessionMutation,
    TError,
    CreateFinchSessionMutationVariables,
    TContext
  >
) =>
  useMutation<CreateFinchSessionMutation, TError, CreateFinchSessionMutationVariables, TContext>(
    ['createFinchSession'],
    (variables?: CreateFinchSessionMutationVariables) =>
      fetchGql<CreateFinchSessionMutation, CreateFinchSessionMutationVariables>(
        CreateFinchSessionDocument,
        variables
      )(),
    options
  )
